import React from 'react';
import { useSelector } from 'react-redux';
import UserItem from './item';

const Users = ({
    mailing_id
}) => {
    const mailing_users = useSelector((state) => state.mailing.scrollers.deposits_users);

    return (
        <div>
            {
                mailing_users.list.map((item, index) => <UserItem login={item.login} index={index} mailing_id={mailing_id} />)
            }
        </div>
    )
}

export default Users;